<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">1. The Silent Years: Cinema Arrives in New Mexico</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. The 1930s and 1940s</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Eureka! New Mexico Is Discovered: The 1950s</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. New Mexico Grooves in the 1960s</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Rediscovered!: The Cargo Years</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Slow and Steady: The 1980s and 1990s</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Give Me a Break and We’ll Film in New Mexico</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. People and Places</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Read the Book, See the Movie</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Show Me the (Tax) Money</span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample">Appendix. The Best Movies Made in New Mexico: Personal Opinion</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7425f2e8